import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink } from "react-router-dom"; // 👈 questo per /admin
import Logo from "../../asset/Logo.png";

export default function NavBar() {
  return (
    <div className="pt-2 pb-2 lg:pl-8 lg:pr-8 flex justify-between items-center gap-2">
      <div className="text-white flex lg:flex-row list-none lg:gap-4 gap-2 font-semibold pb-6 pt-6 bg-[#5b90ab70] w-100 text-center justify-center rounded-3xl lg:text-lg shadow-xl">
        <li>Home Page</li>
        <ScrollLink to="chi-sono" smooth duration={500}>
          <li className="hover:text-[#173341] cursor-pointer">Chi Sono?</li>
        </ScrollLink>
        <ScrollLink to="servizi" smooth duration={500}>
          <li className="hover:text-[#173341] cursor-pointer">Servizi</li>
        </ScrollLink>
        <ScrollLink to="contatti" smooth duration={500}>
          <li className="hover:text-[#173341] cursor-pointer">Contatti</li>
        </ScrollLink>
      </div>

      <div className="lg:pl-8 lg:pr-8 p-3 bg-[#5b90ab70] rounded-3xl shadow-xl">
        <RouterLink to="/admin">
          <img className="w-15" src={Logo} alt="Logo" />
        </RouterLink>
      </div>
    </div>
  );
}
     